import Styles from './Counter.module.scss'
import { Counter as BaseCounter } from 'components/Counter/Counter'

import { CounterProps } from './Types'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import cx from 'classnames'

const Counter = observer(({ total = 0, isActive, classNames }: CounterProps) => {
  const { leftSidebarStore } = useRootStore()

  if (total < 1) {
    return null
  }

  return (
    <div className={cx(Styles.counter, classNames)}>
      <BaseCounter
        count={total}
        noBorder
        className={cx(Styles.baseCounter, { [Styles.show]: leftSidebarStore.isHovered })}
      />
      <span className={cx(Styles.number, { [Styles.active]: isActive, [Styles.hide]: leftSidebarStore.isHovered })}>
        {total}
      </span>
    </div>
  )
})

export { Counter }
